import { render, staticRenderFns } from "./PostWrapper.vue?vue&type=template&id=13465938&scoped=true&"
import script from "./PostWrapper.vue?vue&type=script&lang=js&"
export * from "./PostWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PostWrapper.vue?vue&type=style&index=0&id=13465938&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13465938",
  null
  
)

export default component.exports